import { ChangePasswordModel } from './../../model/change-password.model';
import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';

export const SubmitAction = createAction('[Change Password View] submit',
  props<{ payload: ChangePasswordModel }>());

export const SubmitCompletedAction = createAction('[Change Password Completed] change password completed');
